<nav class="horizontal-nav">
  <ul>
    <li><a href="#requests" class="{{#if requests_active}}active{{/if}}" data-tab="requests">Requests</a></li>
    <li><a href="#stats" class="{{#if stats_active}}active{{/if}}" data-tab="stats">Stats</a></li>
  </ul>
</nav>
